import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { type ProfileType } from '@rma/common-ui-domain/types';
import { ProfileAvatarComponent } from '@rma/profiles/public/ui-profile-avatar';
import { ShortRatingSummaryComponent } from '@rma/profiles/public/ui-short-rating-summary';

export type AvatarSize = 'standard' | 'large';

@Component({
  selector: 'rma-profile-summary',
  imports: [NgClass, NgTemplateOutlet, ProfileAvatarComponent, RouterModule, ShortRatingSummaryComponent],
  templateUrl: './profile-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex space-x-3',
  },
})
export class ProfileSummaryComponent {
  @Input()
  profileType: ProfileType | null = null;

  @Input()
  avatar: string | undefined;

  @Input()
  lazyLoadAvatar = true;

  @Input()
  avatarSize: AvatarSize | null = 'standard';

  @Input()
  name: string | undefined;

  @Input()
  ratingValue: number | undefined;

  @Input()
  reviewCount: number | undefined;

  @Input()
  profileUrl: string | null | undefined;

  @Input()
  backgroundColour: string | undefined;
}
